import {Component, OnInit} from '@angular/core';
import {Subnav} from '../../../models/subnav.model';
import {Evaluation} from '../../../models/evaluation.model';

@Component({
  selector: 'app-career-main',
  templateUrl: './career-main.component.html',
  styleUrls: ['./career-main.component.css']
})

export class CareerMainComponent implements OnInit {

  subnav: Subnav = {
    'routing': 'career',
    'navItems': [
      {
        'navItem': '实习保面试',
        'id': 'intern'
      },
      {
        'navItem': '全职保面试',
        'id': 'full-time'
      },
      {
        'navItem': '名企大牛养成计划',
        'id': 'enterprise'
      },
      {
        'navItem': '面霸计划',
        'id': 'interview'
      },
      {
        'navItem': '私人定制',
        'id': 'vip'
      }
    ]
  };

  evaluation: Evaluation = {
    'title': '职业风向标',
    'fields': ['金融', 'IT', '会计', '咨询', '经济', '快消', '保险', '媒体', '设计', '机械', '数学', '医药'],
    'imgFile': 'career/field.png',
    'alt': '如何定专业'
  };

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/components/career/career-main/career-main.component.ts